module.exports = __webpack_public_path__ + "static/media/eliberty3.f40e32e5.jpg";